import React, { useContext, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import MessageBox from "../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../common/Dictionaries";
import MainAppContext from "../../MainAppContext";
import HeaderFilters from "../../components/Products/sAdjustment/HeaderFilters";
import ParentTableItems from "./AdjustmentPolynomy/ParentTableItems";
import { useSelector } from "react-redux";
import { useGetAdjustmentPolynomyStructure } from "../../hooks/component/sAdjustment/useOfStructures";
import Loading from "../../components/Templates/Site/Loading";
import TablePolynomyHeads from "./AdjustmentPolynomy/TablePolynomyHeads";
import { useGetAdjustmentContractList, useGetAdjustmentIndexList } from "../../hooks/component/sAdjustment/useOfFilters";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

export default function AdjustmentCalculator() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const {
        _firsLoad: firsLoad,
        _filter_Index: filter_Index,
        _filter_Contract: filter_Contract,

        _filter_SelectedIndex: selected_filter_Index,
        _filter_SelectedContracts: selected_filter_Contract,

        _polinomy_Structure_Polinomy: polinomy_Structure_Polinomy,
    } = useSelector((state) => state.adjustmentState);

    useGetAdjustmentIndexList(filter_Index);
    useGetAdjustmentContractList(filter_Contract);

    useGetAdjustmentPolynomyStructure(
        polinomy_Structure_Polinomy,
        (!isNullUndefinedOrEmpty(selected_filter_Index) ? selected_filter_Index.map(x => x.id) : []),
        (!isNullUndefinedOrEmpty(selected_filter_Contract) ? selected_filter_Index.map(x => x.elementId) : []), true)

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    return (
        <div className="col-12 listWithActions h-100">
            <Row>
                <Card className="h-100">
                    <Card.Header>
                        <Card.Title className="d-flex justify-content-between">
                            <h4><b>{t('data-lang-maintainer-title-IntegrationVisor')}</b></h4>
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Card.Footer>
                    <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                        {
                            firsLoad &&
                            <>
                                <div className="align-items-center h-100 pb-4 border-bottom">
                                    <div className="d-none">                                                        
                                        <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                                    </div>
                                    <Row>
                                        <Col>
                                            {
                                                filter_Index && filter_Contract &&
                                                <HeaderFilters
                                                    filter_Index={filter_Index}
                                                    filter_Contract={filter_Contract}
                                                    showIndexFilter={true}
                                                    showAdd={true}
                                                    multiFilterSelection={true}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                </div>
                                {
                                    polinomy_Structure_Polinomy &&
                                    <table className="w-100 mt-2">
                                        <TablePolynomyHeads tableHeads={[
                                            { id: '1',  name: '',                               class: 'w-4',  prop: 'collapseExpand' },
                                            { id: '2',  name: t('data-lang-lbl-contractcode'),  class: 'w-24', prop: 'contractCode'   },
                                            { id: '3',  name: t('data-lang-lbl-code'),          class: 'w-24', prop: 'codigo'         },
                                            { id: '4',  name: t('data-lang-lbl-name'),          class: 'w-24', prop: 'name'           },
                                            { id: '5',  name: t('data-lang-lbl-class'),         class: 'w-24', prop: 'clase'          },
                                        ]} />
                                        <ParentTableItems tableItems={polinomy_Structure_Polinomy} />
                                    </table>
                                }
                            </>
                        }
                        {
                            !firsLoad &&
                            <Loading inputParam_ShowLoading={!firsLoad} />
                        }
                    </Card.Body>
                </Card> 
            </Row>                
        </div>
    ); 
}